import { render, staticRenderFns } from "./TableSafetyRecommendations.vue?vue&type=template&id=963bf2ba"
import script from "./TableSafetyRecommendations.vue?vue&type=script&lang=js"
export * from "./TableSafetyRecommendations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports